//PrimeReact
import { Accordion, AccordionTab } from "primereact/accordion"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Tooltip } from "primereact/tooltip"

//HouseFilter styles
import myStyle from "../../../styles/housing/HousingManagement.module.css"
import { useEffect, useState } from "react"

export default function HouseFilters({
  filters,
  onChangeFilters,
  onNewClick,
  onRefreshClick,
  organizations,
  isLoading,
}) {
  const [search, setSearch] = useState("")
  const [organizationId, setOrganizationId] = useState("")

  useEffect(() => {
    if (
      search !== filters.search ||
      organizationId !== filters.organizationId
    ) {
      setSearch(filters.search)
      setOrganizationId(filters.organizationId)
    }

    //Note: Disable exhaustive deps due to only wanting to fire this event when filters change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  function FilterHeader() {
    return (
      <div className={myStyle.filterHeaderGridContainer}>
        <div className={myStyle.filterHeaderGridTitle}>
          <label>Filters & Sorting</label>
        </div>
        <div className={myStyle.filterHeaderGridButtons}>
          <div className={myStyle.filterButtonContainer}>
            {!!onRefreshClick ? (
              <button
                type="button"
                className={`btn t-tip ${myStyle.filterHeaderButton}`}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!!onRefreshClick) {
                    onRefreshClick()
                  }
                }}
                disabled={isLoading}
              >
                <span className={`material-icons`}>{"autorenew"}</span>
                {" Reload data"}
              </button>
            ) : null}

            <button
              type="button"
              className={`btn t-tip ${myStyle.filterHeaderButton}`}
              onClick={(e) => {
                e.stopPropagation()
                if (!!onNewClick) {
                  onNewClick()
                }
              }}
              disabled={isLoading}
            >
              <span className={`material-icons`}>{"add"}</span>
              {" Add new house"}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <Tooltip target=".hs-t-tip" />
      <Accordion style={{ marginBottom: "10px" }} activeIndex={0}>
        <AccordionTab header={FilterHeader()} disabled={isLoading}>
          <div className={myStyle.filterGridContainer}>
            <div className={myStyle.filterGridItemSearch}>
              <div className={myStyle.label}>Search:</div>
              <div>
                <InputText
                  className={`${myStyle.input} ${myStyle.searchInput}`}
                  value={search}
                  onChange={(value) => {
                    setSearch(value.target.value)
                  }}
                />
              </div>
            </div>
            <div className={myStyle.filterGridItemFilter}>
              <div className={myStyle.label}>Organization Filter:</div>
              <div>
                <Dropdown
                  className={myStyle.input}
                  options={organizations}
                  optionLabel={"organization_name"}
                  optionValue={"organization_id"}
                  placeholder={"All organizations"}
                  value={organizationId}
                  onChange={(e) => {
                    setOrganizationId(e.value)
                  }}
                />
              </div>
            </div>
            <div className={myStyle.filterGridItemButtons}>
              <div className={myStyle.filterButtons}>
                <button
                  className={"btn hs-t-tip"}
                  data-pr-tooltip={"Create a new house"}
                  data-pr-position="bottom"
                  type="button"
                  onClick={() => {
                    onChangeFilters({
                      search: search,
                      organizationId: organizationId,
                    })
                  }}
                >
                  Apply
                </button>
                <button
                  className={`btn ${myStyle.filterButton}`}
                  type="button"
                  onClick={() => {
                    setSearch("")
                    setOrganizationId("")
                    onChangeFilters({ search: "", organizationId: "" })
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    </>
  )
}
